export async function processImage(
  file,
  maxWidth = 3840,
  maxHeight = 2160,
  minWidth = 1280,
  minHeight = 720,
  quality = 0.85,
  maxSizeMB = 10
) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.onload = () => {
      let scale;
      if (img.naturalWidth < minWidth || img.naturalHeight < minHeight) {
        scale = Math.max(minWidth / img.naturalWidth, minHeight / img.naturalHeight);
      } else if (img.naturalWidth > maxWidth || img.naturalHeight > maxHeight) {
        scale = Math.min(maxWidth / img.naturalWidth, maxHeight / img.naturalHeight);
      } else {
        scale = 1;
      }
      const newWidth = Math.floor(img.naturalWidth * scale);
      const newHeight = Math.floor(img.naturalHeight * scale);
      const canvas = document.createElement('canvas');
      canvas.width = newWidth;
      canvas.height = newHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, newWidth, newHeight);
      const generateBlob = (currentQuality) => {
        canvas.toBlob((blob) => {
          if (!blob) {
            reject(new Error("Image processing failed."));
            return;
          }
          if (blob.size <= maxSizeMB * 1024 * 1024 || currentQuality <= 0.2) {
            resolve(blob);
          } else {
            generateBlob(currentQuality - 0.05);
          }
        }, 'image/jpeg', currentQuality);
      };
      generateBlob(quality);
      URL.revokeObjectURL(objectUrl);
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Failed to load image."));
    };
    img.src = objectUrl;
  });
}
